import React, { useEffect, useMemo, useState } from 'react';
import { FaFileDownload, FaGithub, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { usePreferences } from '../context/PreferencesContext';
import PixelDino from '../components/PixelDino';
import '../styles/Home.css';

const homeCopy = {
  tr: { role: 'Bilgisayar M\u00fchendisi', topics: ['Yapay Zek\u00e2', 'Oyun Geli\u015ftirme', 'Web Geli\u015ftirme'], contact: 'Bana ula\u015f', cv: 'CV' },
  en: { role: 'Computer Engineer', topics: ['Artificial Intelligence', 'Game Development', 'Web Development'], contact: 'Contact me', cv: 'CV' },
  ru: { role: '\u0418\u043d\u0436\u0435\u043d\u0435\u0440-\u043f\u0440\u043e\u0433\u0440\u0430\u043c\u043c\u0438\u0441\u0442', topics: ['\u0418\u0441\u043a\u0443\u0441\u0441\u0442\u0432\u0435\u043d\u043d\u044b\u0439 \u0438\u043d\u0442\u0435\u043b\u043b\u0435\u043a\u0442', '\u0420\u0430\u0437\u0440\u0430\u0431\u043e\u0442\u043a\u0430 \u0438\u0433\u0440', '\u0412\u0435\u0431-\u0440\u0430\u0437\u0440\u0430\u0431\u043e\u0442\u043a\u0430'], contact: '\u0421\u0432\u044f\u0437\u0430\u0442\u044c\u0441\u044f', cv: 'CV' },
  fr: { role: 'Ing\u00e9nieur informatique', topics: ['Intelligence artificielle', 'D\u00e9veloppement de jeux', 'D\u00e9veloppement web'], contact: 'Me contacter', cv: 'CV' },
  de: { role: 'Informatikingenieur', topics: ['K\u00fcnstliche Intelligenz', 'Spieleentwicklung', 'Webentwicklung'], contact: 'Kontakt', cv: 'CV' },
  pl: { role: 'In\u017cynier informatyk', topics: ['Sztuczna inteligencja', 'Tworzenie gier', 'Tworzenie stron'], contact: 'Kontakt', cv: 'CV' }
};

const Home = () => {
  const { language } = usePreferences();
  const content = homeCopy[language] || homeCopy.en;
  const topics = useMemo(() => content.topics, [content]);
  const [currentTopic, setCurrentTopic] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    setCurrentTopic(0);
    setDisplayText('');
    setIsTyping(true);
  }, [language]);

  useEffect(() => {
    const phrase = topics[currentTopic];
    const timer = isTyping
      ? (displayText.length < phrase.length
        ? window.setTimeout(() => setDisplayText(phrase.slice(0, displayText.length + 1)), 55)
        : window.setTimeout(() => setIsTyping(false), 1600))
      : (displayText.length > 0
        ? window.setTimeout(() => setDisplayText((text) => text.slice(0, -1)), 32)
        : window.setTimeout(() => { setCurrentTopic((index) => (index + 1) % topics.length); setIsTyping(true); }, 180));
    return () => window.clearTimeout(timer);
  }, [currentTopic, displayText, isTyping, topics]);

  const socials = [
    ['GitHub', 'https://github.com/TalatDemir', FaGithub],
    ['LinkedIn', 'https://www.linkedin.com/in/talat-demir-93462029a/', FaLinkedin],
    ['Instagram', 'https://www.instagram.com/talat.demirr/', FaInstagram]
  ];

  return <div className="home-section content-section">
    <div className="home-layout">
      <div className="home-copy">
        <div className="profile-frame"><div className="profile-border"><div className="profile-photo"><img src="/profile-photo.jpeg" alt="Talat Demir" /></div></div></div>
        <h1>Talat Demir</h1>
        <p className="home-role">{content.role}</p>
        <div className="typing-text-container" aria-label={topics.join(', ')}><p>{displayText}<span className="typing-cursor">|</span></p></div>
        <div className="home-actions">
          <button className="primary-action" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}>{content.contact}</button>
          <a className="secondary-action" href="/Talat_Demir_English_CV.pdf" target="_blank" rel="noopener noreferrer"><FaFileDownload />{content.cv}</a>
        </div>
        <div className="social-links">{socials.map(([name, url, Icon]) => <a key={name} href={url} target="_blank" rel="noopener noreferrer" aria-label={name}><Icon /></a>)}</div>
      </div>
      <div className="dino-stage" aria-hidden="true">
        <img className="pixel-bird" src="/pixel-bird-cutout.png" alt="" />
        <PixelDino />
        <svg className="pixel-cactus" viewBox="0 0 72 120"><path fill="currentColor" d="M28 0h16v32h14V18h10v38H44v64H28V72H12V36h10v22h6V0Zm-6 70h6v12h-6V70Zm22-2h8v10h-8V68Z" /></svg>
      </div>
    </div>
  </div>;
};

export default Home;